import { FC, ReactNode } from 'react';
import { Timeline as MuiTimeline } from '@mui/lab';
import { Stack } from '@mui/material';
import { createUseStyles } from 'react-jss';
import Text from '@/components/text';

export interface TimelineGroup {
  key: string;
  header?: ReactNode;
  items: ReactNode;
}

interface Props {
  groups: TimelineGroup[];
  showEndMessage?: boolean;
}

const useStyles = createUseStyles({
  timeline: {
    '& .MuiTimelineOppositeContent-root': {
      flex: 0.25,
      justifyContent: 'flex-end',
    },
    margin: 0,
    paddingLeft: 0,
  },
  dateWrapper: {
    pointerEvents: 'none',
  },
});

const Timeline: FC<Props> = ({ groups, showEndMessage = true }) => {
  const styles = useStyles();

  return (
    <Stack textAlign="center" gap={2} paddingBottom={2}>
      {groups.map(({ key, header, items }) => (
        <Stack key={key}>
          {!!header && (
            <Stack
              position="sticky"
              paddingY={1}
              zIndex={1}
              top={48}
              className={styles.dateWrapper}
            >
              {header}
            </Stack>
          )}
          <MuiTimeline className={styles.timeline}>{items}</MuiTimeline>
        </Stack>
      ))}
      {showEndMessage && <Text size="small">End of timeline (last 30 days)</Text>}
    </Stack>
  );
};

export default Timeline;
